import tippy from "tippy.js";

export class BenefitTooltips {
  constructor() {
    this.benefits = document.querySelectorAll(".benefit");
    this.init();
  }

  init() {
    this.benefits.forEach((benefit) => {
      this.setupTooltip(benefit);
    });
  }

  setupTooltip(benefit) {
    const benefitDescription = benefit.querySelector(".benefit__description");

    if (!benefitDescription) return;

    tippy(benefit, {
      content: (element) => {
        return benefitDescription.textContent.trim();
      },
      placement: "top",
      arrow: true,
      theme: "spirit21",
    });
  }
}
